import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import Ticker from "../components/landing/Ticker";
import Manifesto from "../components/landing/Manifesto";
import Letter from "../components/landing/Letter";
import Audience from "../components/landing/Audience";
import Roadmap from "../components/landing/Roadmap";
import Curriculum from "../components/landing/Curriculum";
import HostSection from "../components/landing/HostSection";
import Empathy from "../components/landing/Empathy";
import Takeaways from "../components/landing/Takeaways";
import FAQ from "../components/landing/FAQ";
import FinalRegister from "../components/landing/FinalRegister";
import Footer from "../components/landing/Footer";
import StickyCTA from "../components/landing/StickyCTA";

export default function LandingPage() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <Manifesto />
        <Letter />
        <Audience />
        <Roadmap />
        <Curriculum />
        <HostSection />
        <Empathy />
        <Takeaways />
        <FAQ />
        <FinalRegister />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
